export const ACCOUNT_INITIALIZE = 'ACCOUNT_INITIALIZE';

export const accountInitialize = (account) => {
    return {
        type: ACCOUNT_INITIALIZE,
        payload: account
    };
};